import { useEffect, useState } from 'react';

/**
 * False during SSR and the hydration render, true from the next render on.
 *
 * `queryClient.getQueryData()` returns data in the browser but nothing on the
 * server, so branching on it while React hydrates renders a different tree than
 * the HTML it was given - React then throws a hydration mismatch and discards
 * the server markup. Gate every render-time cache read with this flag.
 */
export function useIsHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
